export default "__VITE_ASSET__qYfwVbl3__"